module.exports = __webpack_public_path__ + "static/media/ChannelSong.Odia.ecbbae1a.jpg";